import { FormControl, FormHelperText, FormLabel, Text } from '@chakra-ui/react';
import { FC, PropsWithChildren } from 'react';

import FieldErrorMessage from 'presentation/components/shared/fields/FieldErrorMessage';

interface Props extends FormFieldProps, PropsWithChildren {}

const AppFormControl: FC<Props> = ({ name, label, helperText, children, subLabel }) => {
  return (
    <FormControl>
      {label && <FormLabel>{label}</FormLabel>}
      {subLabel && <Text mb="10px">{subLabel}</Text>}
      {children}
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
      <FieldErrorMessage name={name} />
    </FormControl>
  );
};

export default AppFormControl;
